import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';

export default function Intersection({ onIntersect }) {
  const ref = useRef(null);

  useEffect(() => {
    const target = ref.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onIntersect();
        }
      },
      { rootMargin: '0px', threshold: 1, root: null },
    );

    if (target) observer.observe(target);

    return () => {
      if (target) observer.unobserve(target);
    };
  }, [onIntersect]);

  return <div aria-hidden ref={ref} />;
}
